// extracted by mini-css-extract-plugin
export default {"main":"my-components_main__HexVo","components-list":"my-components_components-list__aG6s6"};